<template>
  <generic-modal
    size
    :title="$t('support service')"
    icon="bug"
    image="/images/icons/support_control.png"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <h3 class="ui dividing header">
          <i class="info circle small icon"></i>
          {{ $t("basic information") }}
        </h3>
        <div class="two fields">
          <div class="field">
            <label for>{{ $t("customer") }}</label>
            <customer-search v-on:clear="clear_customer" v-on:select_customer="select_customer" />
          </div>
          <div class="fields">
            <div class="ui vertical fluid steps" v-if="customer.uuid" style="margin-left:20px">
              <a class="completed step">
                <i class="truck icon"></i>
                <div class="content">
                  <div class="title">{{customer.name}}</div>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div class="field">
          <label for>{{ $t("name") }}</label>
          <input type="text" name="name" v-model="name" />
        </div>
        <div class="field">
          <label for>{{ $t("description") }}</label>
          <textarea name="description" rows="2" v-model="description"></textarea>
        </div>
        <div class="field">
          <label for>{{ $t("support hours") }}</label>
          <input type="text" name="support_hours" v-model="support_hours" />
        </div>
        <div class="ui error message"></div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api /*, error_toast*/ } from "@/utils";
// import { v4 } from "uuid";
// import { deepClone } from "lodash";
import GenericModal from "@/components/GenericModal";
import CustomerSearch from "@/components/CustomerSearch";

export default {
  name: "SupportControlServiceModal",
  components: {
    "generic-modal": GenericModal,
    CustomerSearch
  },
  computed: {},
  props: { service_in: Object },
  data() {
    return {
      name: "",
      description: "",
      customer: {},
      support_hours: 10,
      uuid: undefined
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let isValid = window.jQuery(vm.$refs.form).form("validate form");

        if (!isValid) reject();
        else {
          local_api(vm, "post", "/support_control/do-save", {
            i: vm.uuid,
            n: vm.name,
            d: vm.description,
            h: vm.support_hours,
            c: vm.customer.uuid
          })
            .then(srvce => {
              vm.$emit("succedded", srvce);
              resolve();
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    destroy() {
      this.$emit("destroy");
      // this.$destroy();
    },
    clear_customer() {
      this.customer = {};
    },
    select_customer(customer) {
      console.log(customer);
      this.customer = customer;
    }
  },
  mounted() {
    let vm = this;
    window.jQuery(vm.$refs.form).form({
      fields: {
        name: ["empty"],
        support_hours: ["empty", "integer"]
      }
    });

    if (this.provider && this.provider.uuid) {
      this.name = this.provider.name;
      this.description = this.provider.description;
      this.uuid = this.provider.uuid;
      this.contacts = this.provider.setup.contacts || [];
    }
  },
  created() {
    if (this.service_in) {
      this.uuid = this.service_in.uuid;
      this.name = this.service_in.name;
      this.description = this.service_in.description;
      this.support_hours = this.service_in.support_hours;
    }
  },
  watch: {
    contacts() {
      setTimeout(() => {
        window.jQuery(".ui.contacts.menu .item").tab();
      }, 50);
    }
  },
  updated: function() {}
};
</script>
